import { DateRange } from 'react-day-picker'
import { ptBR as ptBRCalendar } from 'react-day-picker/locale'
import { Calendar } from '@/components/ui/calendar'
import { DatePickerMode } from '../types'

interface DatePickerCalendarProps {
  mode: DatePickerMode
  tempDate: Date | undefined
  tempRange: DateRange | undefined
  onSelectSingle: (date: Date | undefined) => void
  onSelectRange: (range: DateRange | undefined) => void
}

export function DatePickerCalendar({
  mode,
  tempDate,
  tempRange,
  onSelectSingle,
  onSelectRange,
}: DatePickerCalendarProps) {
  if (mode === DatePickerMode.Single) {
    return (
      <Calendar
        mode="single"
        selected={tempDate}
        onSelect={onSelectSingle}
        locale={ptBRCalendar}
      />
    )
  }
  return (
    <Calendar
      mode="range"
      selected={tempRange}
      onSelect={onSelectRange}
      locale={ptBRCalendar}
    />
  )
}
